<template>
  <MiraIcon loading :size="size" />
</template>

<script>
import MiraIcon from 'components/partials/mira/MiraIcon'
export default {
  components: {
    MiraIcon
  },
  props: {
    size: {
      type: [String, Number]
    }
  }
}
</script>
